import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const NAV = [
  ['/catalogo', 'Catálogo', 'catalog'],
  ['/personaliza', 'Personaliza tu idea', 'custom-idea'],
  ['/sobre-mi', 'Sobre mí', 'about'],
  ['/galeria', 'Galería', 'gallery'],
  ['/contacto', 'Contacto', 'contact'],
  ['/faq', 'Preguntas frecuentes', 'faq']
];

function Footer() {
  const { config } = useSiteConfig();
  const socials = [
    [config?.social_instagram, Instagram, 'instagram'],
    [config?.social_facebook, Facebook, 'facebook'],
    [config?.social_twitter, Twitter, 'twitter']
  ].filter(([url]) => url);

  return (
    <footer className="bg-[#111] text-white pt-20 pb-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 pb-14 border-b border-white/10">
          <div className="space-y-5">
            <div className="flex items-center gap-2.5" data-testid="footer-logo" translate="no">
              {config?.logo_url && <img src={config.logo_url} alt="" className="h-9 w-auto object-contain bg-white rounded-md p-1" />}
              <span className="font-display font-bold uppercase notranslate" translate="no">{config?.brand_name || 'kreeo'}<span className="text-[#c9a36b]">.es</span></span>
            </div>
            <p className="text-white/60 leading-relaxed max-w-sm text-sm">{config?.footer_description}</p>
            <div className="flex gap-3">
              {socials.map(([url, Icon, id]) => (
                <a key={id} href={url} target="_blank" rel="noopener noreferrer" className="p-2.5 rounded-md border border-white/15 hover:bg-white hover:text-[#111] transition-colors" data-testid={`footer-${id}-link`} aria-label={id}>
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono-k text-[11px] tracking-[0.25em] uppercase text-white/40 mb-5">Navegación</p>
            <div className="space-y-2.5">
              {NAV.map(([to, label, id]) => (
                <Link key={to} to={to} className="block text-sm text-white/75 hover:text-white transition-colors" data-testid={`footer-${id}-link`}>{label}</Link>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono-k text-[11px] tracking-[0.25em] uppercase text-white/40 mb-5">Contacto</p>
            <div className="space-y-3 text-sm text-white/75">
              <div className="flex items-center gap-2" data-testid="footer-email"><Mail className="w-4 h-4" />{config?.contact_email}</div>
              {config?.contact_phone && <div className="flex items-center gap-2"><Phone className="w-4 h-4" />{config.contact_phone}</div>}
              {config?.contact_address && <div className="flex items-center gap-2"><MapPin className="w-4 h-4" />{config.contact_address}</div>}
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/45">
          <div>© {new Date().getFullYear()} <span className="notranslate" translate="no">{config?.brand_name || 'kreeo'}</span>. Todos los derechos reservados.</div>
          <div className="flex gap-6">
            <Link to="/politica-privacidad" className="hover:text-white" data-testid="footer-privacy-link">Política de Privacidad</Link>
            <Link to="/politica-cookies" className="hover:text-white" data-testid="footer-cookies-link">Política de Cookies</Link>
            <Link to="/aviso-legal" className="hover:text-white" data-testid="footer-legal-link">Aviso Legal</Link>
          </div>
        </div>
        <div className="mt-8 text-center" data-testid="footer-agradecimientos">
          <p className="text-white/35 text-[10px] uppercase tracking-[0.3em] mb-1">Agradecimientos</p>
          <p className="text-white/55 text-xs">Angel · Jordi · Toni · Cristina</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
